var React = require('react');

function MapIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 28.6667C10 28.6667 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 10 28.6667 10 28.6667ZM10 14.6667C12.5773 14.6667 14.6667 12.5773 14.6667 10C14.6667 7.42267 12.5773 5.33333 10 5.33333C7.42267 5.33333 5.33333 7.42267 5.33333 10C5.33333 12.5773 7.42267 14.6667 10 14.6667Z","fill":"#EB5757"}));
}

MapIcon.defaultProps = {"width":"20","height":"29","viewBox":"0 0 20 29","fill":"none"};

module.exports = MapIcon;

MapIcon.default = MapIcon;
